"use client";

// src/primitives/contentPart/ContentPartInProgress.tsx
import { useContentPart } from "../../context/index.js";
var ContentPartPrimitiveInProgress = ({ children }) => {
  const isInProgress = useContentPart((c) => c.status.type === "running");
  return isInProgress ? children : null;
};
ContentPartPrimitiveInProgress.displayName = "ContentPartPrimitive.InProgress";
export {
  ContentPartPrimitiveInProgress
};
//# sourceMappingURL=ContentPartInProgress.js.map